'use strict';

// usage: {{pluralize 5 'Cheese Wheel' plural='Cheese Wheels'}}, {{pluralize 3 Camry possesive=true}}
define('lib/helpers/pluralize',['Handlebars'], function (Handlebars) {
  Handlebars.registerHelper('pluralize', function (n, singular, opt) {
    // make plural an option
    // possesive as an option
    // all ''s' unless ends in y
    function __pluralizeNoun(noun, opt) {
      // Camry = Camry's, Prius = Prius'
      if (opt.hash.possesive) {
        var plural = '\'s';
        if (noun[noun.length - 1] === 's') {
          plural = '\'';
        }
        return new Handlebars.SafeString(noun + plural);
      } else {
        var plural = 's';
        if (/[sxz]$/.test(noun)) {
          plural = 'es';
        } else if(/[^aeioudgkprt]h$/.test(noun)) {
          plural = 'es';
        } else if(/[^aeiou]y$/.test(noun)) {
          return noun.replace(/y$/, 'ies');
        }
        return new Handlebars.SafeString(noun + plural);
      }
    }

    if (n === 1 || !singular) {
      return new Handlebars.SafeString(singular);
    } else {
      return (typeof opt.hash.plural === 'string' ? opt.hash.plural : __pluralizeNoun(singular, opt));
    }
  });
});

